import { render, staticRenderFns } from "./ArticleNav.vue?vue&type=template&id=be2131b0&"
import script from "./ArticleNav.vue?vue&type=script&lang=js&"
export * from "./ArticleNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports